export default defineNuxtPlugin({
  name: 'google-tag-manager',
  parallel: true,
  setup() {
    if (process.env.NODE_ENV !== 'production') {
      return
    }

    useScriptGoogleTagManager({
      scriptOptions: {
        bundle: false,
      },
    })
  },
})
